<div #editor
     class="editor wrapper"
>
  <placeholder-textarea [textModel]="textModel"
                        [placeholder]="placeholder"
                        (textChange)="onTextChanged($event)"
  >
  </placeholder-textarea>

  <div class="toolbar">
    <text-alignment-chooser *ngIf="controls.alignment"
                            [alignment]="textModel.horizontalAlignment"
                            (alignmentChange)="onAlignmentChanged($event)"
    ></text-alignment-chooser>

    <color-chooser *ngIf="controls.color"
                   [currentColor]="textModel.color"
                   (currentColorChange)="onColorChanged($event)"
    ></color-chooser>

    <font-chooser *ngIf="controls.font"
                  [fontName]="fontName"
                  (fontNameChange)="onFontNameChanged($event)"
    ></font-chooser>

    <text-size-chooser #sizeChooser
                       *ngIf="controls.fontSize"
                       [fontSize]="textModel.fontSize"
                       [minFontSize]="minFontSize"
                       (fontSizeChange)="onFontSizeChanged($event)"
                       [enabled]="!isTextEmpty"
    ></text-size-chooser>
  </div>

  <div class="buttons">
    <button mat-raised-button translate
            size="small"
            (click)="onCancelClicked()">
      i18n.button.cancel
    </button>
    <button mat-raised-button color="primary" translate
            size="small"
            (click)="onApplyClicked()">
      i18n.button.apply
    </button>
  </div>

  <toast #toast></toast>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/text-editing/text-editing.component.html